module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_discharging_solid.27e011ac.svg";